import { db } from "../../services/firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  updateDoc,
  setDoc
} from "firebase/firestore";

export async function getUserDataClient(uid) {
try {
    const userRef = doc(db, 'users', uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) {
      throw new Error("User not found");
    }
    return userSnap.data();
} catch (error) {
    console.error('Error fetching user data:', error);
}
};

export async function getUserBookingsClient({uid}) {
  const bookingsRef = collection(db, 'users', uid, 'bookings');
  const snapshot = await getDocs(bookingsRef);
  const bookings = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  return bookings.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));
}

export async function cancelUserBookingClient({booking, uid}) {
  await Promise.all([
    updateDoc(doc(db, 'services', booking.serviceId, 'bookings', booking.bookingId), { status: 'cancelled' }),
    updateDoc(doc(db, 'users', uid, 'bookings', booking.id), { status: 'cancelled' }),
    updateDoc(doc(db, 'providers', booking.providerId, 'bookings', booking.id), { status: 'cancelled' })
  ]);
}

export async function getProviderAndServiceDataClient({providerId, serviceId}) {
  const [providerDoc, serviceDoc] = await Promise.all([
    getDoc(doc(db, 'providers', providerId)),
    getDoc(doc(db, 'services', serviceId))
  ]);
  
  return {
    provider: providerDoc.exists() ? providerDoc.data() : null,
    service: serviceDoc.exists() ? serviceDoc.data() : null
  };
}

export async function updateUserProfileFieldClient({uid, field, value}) {
  const userRef = doc(db, 'users', uid);
  await updateDoc(userRef, { [field]: value });
}

export async function getUserFavoritesClient({ userId }) {
  const userRef = doc(db, 'users', userId);
  const docSnap = await getDoc(userRef);
  
  if (docSnap.exists()) {
    return docSnap.data().favorites || [];
  } else {
    await setDoc(userRef, { favorites: [] });
    return [];
  }
}

export async function checkUserExistsClient({ email }) {
  // This would typically query by email, but for now return false
  return { exists: false };
}